<template>
    <common-page flex-column card-content>
        <mini-table read-only
                    :items="tasks"
                    :loading="queryLoading"
                    entity-name="sithMesMstMaterial"
                    need-model-fields>
            <template #leftHeader>
                <mini-button :loading="autoProcessing"
                             @btnClick="autoProcess">
                    <i v-show="!autoProcessing" class="fa-solid fa-check"></i>
                    {{ processName }}
                </mini-button>
            </template>
        </mini-table>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

export default {
    name: "MaterialBaseExtendTaskPage",
    components: {MiniButton, MiniTable, CommonPage},
    data() {
        return {
            projectKamId: null,
            queryLoading: false,

            tasks: [],
            autoProcessing: false,
            processName: ''
        }
    },
    created() {
        this.projectKamId = this.$route.query.projectKamId;
        this.getAllTask('claim');
    },
    methods: {
        getAllTask(type = 'todo') {
            if (!this.projectKamId) {
                return;
            }
            this.queryLoading = true;
            let url = process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstMaterial/workflow/find-by-query-form";
            this.$store.dispatch('api/post', {
                url: url,
                data: {
                    workflowQueryTypeFilter: type,
                    projectKamIdFilter: this.projectKamId
                }
            }).then(response => {
                if (response.data && response.data.list) {
                    this.tasks = response.data.list;
                    if (type === 'todo') {
                        this.routeTo();
                    } else {
                        if (this.tasks.length === 0) {
                            this.$message.warning('似乎已全部认领，尝试直接点击上方处理按钮');
                        }
                    }
                }
            }).finally(() => this.queryLoading = false);
        },
        autoProcess() {
            this.autoProcessing = true;
            this.processName = '认领中...'
            let taskIds = [];
            for (let row of this.tasks) {
                if (row.workflowTask && row.workflowTask.taskInstanceId) {
                    taskIds.push(row.workflowTask.taskInstanceId);
                }
            }
            if (taskIds.length > 0) {
                this.$store.dispatch('api/post', {
                    url: process.env.VUE_APP_EM_WORKFLOW_URL + "/claimTask",
                    data: {
                        taskIdList: taskIds
                    }
                }).then(() => {
                    this.processName = '查询待办中...';
                    this.getAllTask();
                }).catch(() => this.clearProcess());
            } else {
                this.processName = '查询待办中...';
                this.getAllTask();
            }
        },
        routeTo() {
            this.$message.info("正在跳转");
            let tempList = [];
            for (let row of this.tasks) {
                if (row.status === 'task7') {
                    tempList.push(row);
                }
            }
            if (tempList.length > 0) {
                this.$router.push({
                    name: 'sithMesMstMaterialTaskBatch',
                    params: {
                        rows: tempList
                    }
                });
            }
            this.clearProcess();
        },
        clearProcess() {
            this.autoProcessing = false;
            this.processName = '';
        },
    }
}
</script>

<style scoped>

</style>
